import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Custom hook to activate existing students (POST with no body)
 */
export const useActivateStudents = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState("");

    const { axiosInstance } = useAxios();

    /**
     * Activate existing students
     * @param {() => void} [onSuccess] - Callback on success
     * @returns {Promise<void>}
     */
    const activateStudents = async (onSuccess) => {
        try {
            setLoading(true);
            setError("");
            setSuccess(false);
            setMessage("");

            const url = `${TENANT_DOMAIN}/billing/subscription-cycles/activate-existing-students`;
            const response = await axiosInstance.post(url);

            setSuccess(true);
            setMessage(response.data?.message || "Students activated successfully.");

            if (onSuccess) {
                onSuccess();
            }
        } catch (err) {
            setSuccess(false);

            if (err?.response?.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        success,
        message,
        activateStudents,
    };
};